import { NgModule } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';

@NgModule({
  imports: [AuthModule.forRoot({
    config: [
      {
        configId: 'dashboard-ui',
        authority: environment.identityServer.baseUrl,
        clientId: 'dashboard-ui',
        redirectUrl: location.origin + '/login-callback',
        postLogoutRedirectUri: location.origin,
        scope: 'openid dashboard-api',
        responseType: 'code',
        autoUserInfo: false,
        startCheckSession: false,
        silentRenew: true,
        silentRenewUrl: location.origin + '/silent-renew.html',
        renewTimeBeforeTokenExpiresInSeconds: 3600,
        logLevel: LogLevel.Warn,
        // GET /connect/authorize?client-id...
        customParamsAuthRequest: { acr_values:'tenant:' + sessionStorage.getItem('mruTenant') ?? '', login_hint: sessionStorage.getItem('mruLoginHint') ?? '' },
        // POST /connect/token
        customParamsCodeRequest: { acr_values:'tenant:' + sessionStorage.getItem('mruTenant') ?? '', login_hint: sessionStorage.getItem('mruLoginHint') ?? '' },
      },
      {
        configId: 'dashboard-support-ui',
        authority: environment.identityServer.baseUrl,
        clientId: 'dashboard-support-ui',
        redirectUrl: location.origin + '/support-login-callback',
        postLogoutRedirectUri: location.origin,
        scope: 'openid dashboard-api',
        responseType: 'code',
        autoUserInfo: false,
        startCheckSession: false,
        silentRenew: true,
        silentRenewUrl: location.origin + '/silent-renew.html',
        renewTimeBeforeTokenExpiresInSeconds: 600,
        logLevel: LogLevel.Warn,
        // GET /connect/authorize?client-id...
        customParamsAuthRequest: { acr_values: 'tenant:' + sessionStorage.getItem('mruTenant-support') ?? '' },
        // POST /connect/token
        customParamsCodeRequest: { acr_values: 'tenant:' + sessionStorage.getItem('mruTenant-support') ?? ''},
       }
  ]
  })],
  providers: [],
  exports: [AuthModule],
})
export class IdentityServerConfigModule {}
